export const getLeaderboardXpGap = (
	items: { rank: number; xp: number }[],
	currentUser: { rank: number; xp: number } | undefined,
) => {
	if (!currentUser) {
		return 0;
	}

	const userRank = currentUser.rank;

	if (userRank === 1) {
		return 0;
	}
	const userXp = currentUser.xp;
	const userIsInLeaderboard = items.some((item) => item.rank === userRank);

	if (userIsInLeaderboard) {
		const xpAbove = items.find((item) => item.rank === userRank - 1)?.xp;
		return xpAbove !== undefined ? Math.max(0, xpAbove - userXp + 1) : 0;
	}

	const lastPodiumXp = items[items.length - 1]?.xp;
	return lastPodiumXp !== undefined
		? Math.max(0, lastPodiumXp - userXp + 1)
		: 0;
};
